const site = {
  name: 'H2 Fresh',
  fullName: 'H2 Fresh | Kerala Restaurant & Halal Meat Market',
  tagline: 'Authentic Malabar flavors and hand-cut Zabiha halal meat, under one roof, in the heart of Frisco.',
  address: {
    line1: '8992 Preston Rd #106',
    line2: 'Frisco, TX 75034',
    full: '8992 Preston Rd #106, Frisco, TX 75034',
    mapsUrl: 'https://maps.google.com/?q=8992+Preston+Rd+%23106,+Frisco,+TX+75034',
    embedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3342.5956474867885!2d-96.82156082429076!3d33.15373037349648!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c3c8c8c8c8c8c%3A0x8c8c8c8c8c8c8c8c!2s8992%20Preston%20Rd%20%23106%2C%20Frisco%2C%20TX%2075034!5e0!3m2!1sen!2sus!4v1703123456789!5m2!1sen!2sus'
  },
  phones: [
    { label: 'Primary', display: '(469) 294-6767', tel: '+14692946767' },
    { label: 'Secondary', display: '(469) 400-1147', tel: '+14694001147' }
  ],
  hours: {
    summary: 'Tue – Sun · 9:00 AM – 9:00 PM',
    closedNote: 'Closed Mondays',
    rows: [
      { day: 'Monday', hours: 'Closed' },
      { day: 'Tuesday', hours: '9:00 AM – 9:00 PM' },
      { day: 'Wednesday', hours: '9:00 AM – 9:00 PM' },
      { day: 'Thursday', hours: '9:00 AM – 9:00 PM' },
      { day: 'Friday', hours: '9:00 AM – 9:00 PM' },
      { day: 'Saturday', hours: '9:00 AM – 9:00 PM' },
      { day: 'Sunday', hours: '9:00 AM – 9:00 PM' }
    ]
  },
  brandLines: {
    eyebrow: 'Welcome, come in and enjoy the flavors of Kerala!',
    headline: 'H2 FRESH',
    subhead: 'Kerala Restaurant & Halal Meat Market'
  },
  copyright: '© 2026 H2 Fresh Kerala Restaurant & Meat Market. All rights reserved.',
  servingSince: 'Family-owned and serving Frisco since 2024.'
};

export default site;
